import { jsx, jsxs } from 'react/jsx-runtime';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { useLlm } from '../../../useLlm/useLlm.js';
import { Cta } from '../../components/Cta/cta.js';
import { Text } from '../../components/Text/text.js';

const FormRequest = _ref => {
  let {
    last
  } = _ref;
  const label = useLabel();
  const {
    formRequest
  } = useLlm(state => state.actions);
  return jsx("div", {
    className: "llm__row",
    children: jsxs("div", {
      className: "llm__col --md-8 --lg-6",
      children: [jsx(Text, {
        body: label('llm.formRequestTitle')
      }), last && jsxs("div", {
        className: "llm__ctas",
        children: [jsx(Cta, {
          type: "simple",
          label: label('llm.formRequestYes'),
          onClick: () => formRequest(true)
        }), jsx(Cta, {
          type: "simple",
          label: label('llm.formRequestNo'),
          onClick: () => formRequest(false)
        })]
      })]
    })
  });
};

export { FormRequest };
//# sourceMappingURL=FormRequest.js.map
